import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with show/hide eye toggle.
 * All password fields in the app should use this so users can preview what they typed.
 */
export default function PasswordInput({ value, onChange, placeholder, required, testId, className = "", autoComplete = "current-password" }) {
  const [show, setShow] = useState(false);
  return (
    <div className={`relative ${className}`}>
      <input
        type={show ? "text" : "password"}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        className="input-bizma pr-11"
        data-testid={testId}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-bizma-subtext hover:text-bizma-ink transition-colors"
        aria-label={show ? "Sembunyikan password" : "Tampilkan password"}
        data-testid={`${testId}-toggle`}
      >
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
